export const PROGRESS_GRADIENT_COLOR = { '0%': '#108ee9', '100%': '#87d068' };
